import {
  useTeachingBlockForSubjectContainerQuery,
  useTeachingBlockForVersionQuery,
  useTeachingBlocksQuery,
} from '../../../types/planung-graphql-client-defs';

/**
 * Die Antworten enthalten nur `TeachingBlockItem` und `TeachingBlockVersionListItem`. Mutationen an
 * Versionen und Karten liefern aber die Knotentypen; damit sie diese Abfragen weiter verwerfen
 * (Versionsliste, Kartenzahl, Entwurf-Status), hängen deren Typnamen hier an.
 */
const TEACHING_BLOCK_QUERY_CONTEXT = {
  additionalTypenames: [
    'TeachingBlockItem',
    'TeachingBlock',
    'TeachingBlockVersion',
    'TeachingBlockCard',
    'SubjectContainer',
    'SubjectContainerItem',
  ],
};

export const useTeachingBlocks = (
  schoolYearUuid: string | undefined,
  options?: { onlyWithActiveVersion?: boolean },
) => {
  const [{ data, fetching }] = useTeachingBlocksQuery({
    variables: { schoolYearUuid: schoolYearUuid ?? '', onlyWithActiveVersion: options?.onlyWithActiveVersion },
    pause: !schoolYearUuid,
    context: TEACHING_BLOCK_QUERY_CONTEXT,
  });
  return { teachingBlocks: data?.teachingBlocks, fetching };
};

export const useTeachingBlockForVersion = (versionUuid: string | undefined) => {
  const [{ data, fetching }] = useTeachingBlockForVersionQuery({
    variables: { versionUuid: versionUuid ?? '' },
    pause: !versionUuid,
    context: TEACHING_BLOCK_QUERY_CONTEXT,
  });
  return { teachingBlock: data?.teachingBlockForVersion ?? undefined, fetching };
};

export const useTeachingBlockForSubjectContainer = (
  schoolYearUuid: string | undefined,
  subjectContainerUuid: string | undefined,
) => {
  const [{ data, fetching }] = useTeachingBlockForSubjectContainerQuery({
    variables: { schoolYearUuid: schoolYearUuid ?? '', subjectContainerUuid: subjectContainerUuid ?? '' },
    pause: !schoolYearUuid || !subjectContainerUuid,
    context: TEACHING_BLOCK_QUERY_CONTEXT,
  });
  return { teachingBlock: data?.teachingBlockForSubjectContainer ?? undefined, fetching };
};
